import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useRouteMatch } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';

import { isBranchEnv } from 'brand-config';
import { useStore } from 'core/store';
import { getBackgroundPreference } from 'core/components/theme/background';
import NeighborhoodArtwork from 'core/components/layout/assets/neighborhood.svg?react';
import Home from 'core/components/illustrated-loader/assets/checkhome.svg?react';
import Auto from 'core/components/illustrated-loader/assets/checkauto.svg?react';
import Farm from 'core/components/illustrated-loader/assets/teamwork.svg?react';
import Condo from 'core/components/illustrated-loader/assets/neighbor.svg?react';
import Renters from 'core/components/illustrated-loader/assets/watering.svg?react';
import HomeAuto from 'core/components/illustrated-loader/assets/homeauto.svg?react';
import UmbrellaBadge from 'core/assets/svg/umbrella-badge.svg?react';
import { GENERIC_ART, getNavArt } from './nav-illustration-art';
import useStyles from './nav-illustration.styles';

const artwork = {
  [GENERIC_ART]: NeighborhoodArtwork,
  home: Home,
  auto: Auto,
  farm: Farm,
  condo: Condo,
  renters: Renters,
  homeauto: HomeAuto
};

// The tree and house without the gutter's empty sky, so the scene fills the rail's width.
const GENERIC_VIEW_BOX = '10 -10 340 370';

// Decorates the condensed nav rail with art for the page: the customer's or offer's lines, or a generic scene.
const NavIllustration = observer(() => {
  const classes = useStyles();
  const theme = useTheme();
  const { account, offer: offerStore } = useStore();
  const [{ gutterArtwork }] = useState(getBackgroundPreference);
  const customerMatch = useRouteMatch('/customer/:accountId');
  const policyMatch = useRouteMatch('/customer/:accountId/policy/:policyId');
  const offerMatch = useRouteMatch('/offer/:offerId');
  if (!theme.condensedLayout || !isBranchEnv || !gutterArtwork) {
    return null;
  }
  const shown = getNavArt({
    accountId: customerMatch?.params.accountId,
    policyId: policyMatch?.params.policyId,
    offerId: offerMatch?.params.offerId,
    account,
    offerStore
  });
  if (!shown) {
    return null;
  }
  const Artwork = artwork[shown.art];
  const generic = shown.art === GENERIC_ART;
  return (
    <div className={classes.root} aria-hidden="true" data-testid="nav-illustration" data-art={shown.art}>
      {/* A new key replays the assemble whenever the art changes. */}
      <div key={`${shown.art}:${shown.umbrella}`} className={classes.scene}>
        <Artwork
          className={classes.art}
          focusable="false"
          preserveAspectRatio="xMidYMax meet"
          {...(generic && { viewBox: GENERIC_VIEW_BOX })}
        />
        {shown.umbrella && <UmbrellaBadge className={classes.umbrella} focusable="false" data-testid="nav-umbrella" />}
      </div>
    </div>
  );
});

export default NavIllustration;
